import React, { useState, useEffect, useContext } from 'react';

import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Alert,
  Badge,
  ProgressBar
} from 'react-bootstrap';

import axios from 'axios';
import FileDownload from 'js-file-download';

import { ReactSortable } from "react-sortablejs";
import { MessageModal  } from '../../components';

import Utils from '../../Utils';
import _ from 'lodash';

import { PhotoForm, QuestionForm, VideoForm, FileForm } from './../BuilderSteps';
import CustomTemplateList from './CustomTemplateList';
import AskTitle from './AskTitle';
import UserContext from './../../contexts/UserContext';

const Step3 = (props) => {

  const [stepData, setStepData] = useState(_.get(props, 'stepData', {}));

  const { userData,setPkgSize, getPkgSize, deleteDraft, saveDraft, getMaxScormSize, pkgInfo, setPkgInfo} = useContext(UserContext);
  const [slideParams, setSlideParams] = useState({ show: false, pos: 0, mode: 1, type: false, data: {} }); // 0 = Add, 1 = Edit, //type=Photo,Question,Video, // data = existing data
  
  const [slides, setSlides] = useState(_.get(stepData, 'slides', []));
  const [loading, setLoading] = useState(false);
  const [manage, setManage] = useState(false);
  const [prepare, setPrepare] = useState(false);
  const [publish, setPublish] = useState(false);
  const [remove, setRemove] = useState(false);
  const [listManage, setListManage] = useState(false);
  const [draft, setDraft] = useState(false);
  const [isWeb, setWeb] = useState(false);
  const [flagScorm, setFlagScorm] = useState(false);
  const [message, setMessage] = useState(false);
  const [flagWeb, setFlagWeb] = useState(false);
  const [userLicense, setUserLicense] = useState(false);
  const [buyPlan, setBuyPlan] = useState(false);
  const scormsize_in_mb = getMaxScormSize();//_.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  
  
  const initializeSlide = () => {
    if (stepData.mode === 2 && slides.length == 1) {
      let idx = 0;
      setSlideParams({ ...slideParams, show: true, pos: idx + 1, mode: 1, type: slides[idx].type, data: slides[idx].data });
    }
  }

  useEffect(() => {
    initializeSlide();
    setManage(true);
    checkDraft();
  }, []);

  useEffect(() => {
    setStepData({ ...stepData, slides, folder: false });   
  }, [slides]);

  useEffect(() => {    
    props.onSlideSave(stepData);
  }, [stepData]);

  const [editTitle, setEditTitle] = useState(false);

  const changeTitle = (val) => {
    setStepData({ ...stepData, sprops: val});
    // setStepData({ ...stepData, sprops: val, folder: false });
    
    setEditTitle(false);
  }

  const prepareScorm = () => {
    
    if (stepData.sprops.title === "" || (isScormCountable() && _.get(stepData, 'sprops.pass_score', '') == '')) {
      setEditTitle(true);
      return;
    }

    setLoading('Preparing SVASU preview.. please wait..');
    setStepData({ ...stepData, folder: false });

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';

    axios.post(Utils.apiUrl('Scorm/prepare'), { scorm: _.omit(stepData, 'slides', 'step'), slides: slides, size : getPkgSize() }, headers).then(res => {
      setLoading(false);      
      if (res.data.success) {
        setStepData({ ...stepData, 
                    folder: res.data.folder,
                    pkg_id : res.data.pkg, 
                    validity: res.data.validity, 
                    validityMessage : res.data.message, 
                    storage : res.data.size,
                    cloud : res.data.cloud});
        Utils.addToUserData({ pkg_id : res.data.pkg, validity: res.data.validity, size : res.data.size});
        window.open(process.env.REACT_APP_API_URL + 'scorm/' + res.data.folder + '/launch.html');
      }       
      else {
        window.alert("Error occurred, Contact Admin!");
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
    setFlagScorm(true);
    setFlagWeb(false);
    setPublish(true);
  }

  const prepareWeb = () => {
    setWeb(true);
    if (stepData.sprops.title === "") {
      setEditTitle(true);
      return;
    }
    setFlagWeb(true);
    setFlagScorm(false);
    setLoading('Preparing SVASU preview.. please wait..');
    setStepData({ ...stepData, folder: false });

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';

    axios.post(Utils.apiUrl('Web/prepare'), { scorm: _.omit(stepData, 'slides', 'step'), slides: slides, size : getPkgSize() }, headers).then(res => {
      setLoading(false);
      if (res.data.success) {
        setStepData({ ...stepData, 
              folder: res.data.folder, 
              pkg_id : res.data.pkg, 
              validity: res.data.validity, 
              validityMessage : res.data.message, 
              storage : res.data.size,
              cloud : res.data.cloud });
        Utils.addToUserData({ pkg_id : res.data.pkg, validity: res.data.validity, size : res.data.size});
        window.open(process.env.REACT_APP_API_URL + 'web/' + res.data.folder + '/index.html');
      } else {
          window.alert('Some error occurred on server!');
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
    setPublish(true);
  }

  const download = ( courseType, id, callback) => {
    var headers = { ...Utils.apiHeaders(), "responseType": "blob" };
    axios.get(Utils.apiUrl(`${courseType}/download?id=` + id), headers)
    .then((res) => {
      FileDownload(res.data, stepData.sprops.title + '_' + Date.now() + '.zip');
      setMessage(false);
      callback();
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }



  const publishScorm = () => {
    Utils.setCourseType(false);
    setMessage(['info', ['Please wait. We are processing your file.']]);
    setLoading('Publishing SVASU.. please wait..');
    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';
    let npeJson = {
      'uid'           : userData.id,
      'username'      : userData.username,
      // 'publishes'     : userData.publishes,
      'course-type'   : 'scorm',
      'course-size'   : getPkgSize(),
      'folder'  : ''
    };

    axios.post(Utils.apiUrl('Scorm/publish'), { folder: stepData.folder, 
                  npeJson: npeJson, 
                  scorm: _.omit(stepData, 'slides', 'step'), 
                  slides: slides, 
                  scorm_id: _.get(stepData, 'scorm_id', 0),
                  pkg_type: userData.storage,
                  size: getPkgSize() }, headers)
      .then(res => {
        if (res.data) {
          download('Scorm', res.data.scorm_id, () => {
            let udata = Utils.getUserData();
            if(udata['draft'] === 'edit') Utils.addToUserData({draft: false});
            setPkgInfo({...pkgInfo, id: res.data.pk_id});
            Utils.saveUserData(Utils.getUserData(), { step: 1 });
            setLoading(false);
            
            if(res.data.cloud == 0){              
              //if package is 1 then delete scorm just after publish
              axios.delete(
                Utils.apiUrl(`Scorm/deletescorm/:${res.data.scorm_id}`),
                Utils.apiHeaders()
              )
              .then(res => console.log(res.data.success))
              .catch(err => {
                console.log(err)
              });
            }
            window.setTimeout(function(){
              window.location.href = process.env.PUBLIC_URL + '/scorms';
            }, 1000);            
          });
        } else {
          window.alert('Some error occurred on server!');
        }
      }).catch(err => {
        window.alert(JSON.stringify(err));
      });
  }

  const publishWeb = () => {
    Utils.setCourseType(false);
    setMessage(['info', ['Please wait. We are processing your file.']]);
    setLoading('Publishing WEB version.. please wait..');

    var headers = { ...Utils.apiHeaders() };
    headers['headers']['Accept'] = 'application/json';
    let npeJson = {
      'uid'           : userData.id,
      'username'      : userData.username,
      // 'publishes'     : userData.publishes,
      'course-type'   : 'web',
      'course-size'   : getPkgSize(),
      'folder'  : ''
    };

    axios.post(Utils.apiUrl('Web/publish'), { folder: stepData.folder, 
          npeJson : npeJson,  
          scorm: _.omit(stepData, 'slides', 'step'), 
          slides: slides, 
          scorm_id: _.get(stepData, 'scorm_id', 0),
          pkg_type: userData.storage,
          size : getPkgSize()}, headers).then(res => {
      if (res.data) {
        download('Web', res.data.scorm_id, () => {
          let udata = Utils.getUserData();
          if(udata['draft'] === 'edit') Utils.addToUserData({draft: false});
          setPkgInfo({...pkgInfo, id: res.data.pk_id});
          Utils.saveUserData(Utils.getUserData(), { step: 1 });
          setLoading(false);
          if(res.data.cloud == 0){              
            //if package is 1 then delete scorm just after publish
            axios.delete(
              Utils.apiUrl(`Scorm/deletescorm/:${res.data.scorm_id}`),
              Utils.apiHeaders()
            )
            .then(res => console.log(res.data.success))
            .catch(err => {
              console.log(err)
            });
          }
          window.setTimeout(function(){
            window.location.href = process.env.PUBLIC_URL + '/scorms';
          }, 1000);
        });
      } else {
          window.alert('Some error occurred on server!');
      }
    }).catch(err => {
      window.alert(JSON.stringify(err));
    });
  }

  const updateManage = () => {
    setManage(true);
    setPrepare(false);
    setPublish(false);
  }

  const updatePrepare = () => {
    if (slides.length > 0) {
      if(prepare){
        setPrepare(true);
        setSlides(slides);
        setManage(true);
        setPublish(false);
      }  
    }
  }

  const checkDraft = () => {  
    axios.get(Utils.apiUrl('Draft/checkUserDraft'), Utils.apiHeaders())
      .then(res => {        
          if(res.data.success){
            setDraft(res.data.data);
          }
        }
      )
      .catch(err => console.log("Draft check error : ", err));
}
  const handleBuyPlan = () => {
    window.location.href = process.env.REACT_APP_URL + '#buy-now'
  }


  const handleDraft = () => {
    //check whether user has purchased any plan
    axios.get(Utils.apiUrl(`Package/getUserLicense`), Utils.apiHeaders())
      .then(res => {        
        setUserLicense(res.data.data);
        if(_.isUndefined(res.data.data.package)){
          setBuyPlan(true);
          setMessage(['info', ["To save your course as a draft, please buy any of our plan."]]);
          return;
        }else{
          if(parseInt(draft) > 0){
            const ans = window.confirm('You already have saved draft.\n' + 
              'Saving these changes will overwrite the earlier one.\n' +
              'Do you still want to continue saving?')
            if(!ans) return;  
            else deleteDraft(userData.draft, (success, msg) => {console.log(msg);});
    
          }else if(userData.draft == 'edit'){
            const ans = window.confirm('Saving these changes will overwrite the earlier one.\n' +
              'Do you still want to continue saving?');
            if(!ans) return;
            else deleteDraft((success, msg) => {console.log(msg);});      
          }
          saveDraft('step3', (success, msg) => {
            if(success){
              setMessage([success ?  'info' : 'error' , msg]);  
              window.location.href = process.env.PUBLIC_URL + '/builder';
            }
          })
        }
      })
      .catch(err => console.log("License Error : ",  err));
  }

  const updatePublish = () => {
    if (prepare === true) {
      setPublish(true);
    }
  }

  const showManage = () => {
    setListManage(true);
  }
  const hideManage = () => {
    setListManage(false);
  }

  const renderManage = () => {
    return <div className="instructions">
      <h3 className="my-3">
        {listManage === false && <><span className="clickable" onClick={showManage}>+ </span>Click "+" to manage your slides.</>}
        {listManage === true && <><span className="clickable" onClick={hideManage}>- </span>Click "-" to hide below details.</>}</h3>

      {listManage && <span>
        <ol>
          <li>Add more slides by clicking the <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} alt="Add Slide" width="15" pos={0} /><strong> Add Slide</strong>.</li>
          <li>Drag and drop slides to change the sequence of slides.</li>
          <li>Remove slides by clicking <img className="remove" src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} alt="Remove Slide" /><strong> Remove Slide</strong>.</li>
          <li>Click on any slide to edit it.</li>
        </ol>
      </span>}
      <Row className="changeCourseName">
        <Col>
          <Alert variant="warning">
            {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}&altd=${stepData.fname}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" title="Edit SVASU Properties" onClick={() => setEditTitle(true)} />
          </Alert>
        </Col>
      </Row>

      <Card.Body className="card-box w-100 my-3 py-4 text-center bg-light">
        {slides.length === 0 && <Alert>
          <p>No slide added yet!</p>
          <p>Click <span className="fa fa-plus" /> below to add the required component.</p>
          <p><img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} alt="Add Slide" title="Add Slide" className="clickable" width="25" pos={0} onClick={addSlideHandler} /></p>
        </Alert>}
        {slides.length > 0 && <ReactSortable
          list={slides}
          setList={setSlides}
        >
          {slides.map((slide, idx) => <div key={idx} className="my-2" style={{ display: 'inline-block' }}>
            <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} title="Add Slide" className="clickable plus" pos={idx} alt="Add Slide" onClick={addSlideHandler} />
            <div className="slides" >
              <img className="remove" src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} sid={slide.sid} title="Remove Slide" onClick={removeSlideHandler} alt="Remove Slide" />
              {slide.type === 'Photo' && (<>
                {(_.get(slide, 'data.manual', false) === false && _.get(slide, 'folder', false) === false)&& <img alt={`Slide ${slide.sid}`} chk="1" src={Utils.apiUrl(`image?d=${stepData.fname}&f=${slide.sid}.jpg`)} sid={slide.sid} onClick={openSlideEditor} />}
                {(_.get(slide, 'data.manual', false) === false && _.get(slide, 'folder', false) !== false ) && <img alt={`Slide ${slide.sid}`} chk="2" src={Utils.apiUrl(`image?d=${slide.folder}&f=${slide.sname}`)} sid={slide.sid} onClick={openSlideEditor} />}                
                {_.get(slide, 'data.manual', false) === true && <img alt={`Slide ${slide.sid}`} src={Utils.apiUrl(`image?f=${slide.data.fname}`)} chk="4" sid={slide.sid} onClick={openSlideEditor} />}
              </>)}
              {slide.type === 'Question' && <img src={`${process.env.PUBLIC_URL}/images/quiz_slide.png`} alt={`Slide ${slide.sid}`} className="p-5" sid={slide.sid} onClick={openSlideEditor} />}
              {slide.type === 'Video' && <img src={`${process.env.PUBLIC_URL}/images/video_slide.png`} alt={`Slide ${slide.sid}`} className="p-5" sid={slide.sid} onClick={openSlideEditor} />}
              {slide.type === 'Template' && <img className="img-fluid" src={`${process.env.PUBLIC_URL}/images/template-thumbnails/slide-${slide.data.template}.jpg`} alt={`Slide ${slide.sid}`} sid={slide.sid} onClick={openSlideEditor} />}
            </div>
            {idx === (slides.length - 1) && <img src={`${process.env.PUBLIC_URL}/images/plus_icon_purple.png`} title="Add Slide" className="clickable" pos={idx + 1} alt="Add Slide" onClick={addSlideHandler} />}
          </div>)}
        </ReactSortable>}
        <br /><hr />
        <Row>

          <Col className="text-center">
            Once you have finalized the slides, click the "Prepare Course" button to view the course.<br />
            You can click "Save as Draft" to edit and publish the course later.<br /><br />
            {slides.length === 0 && <Button variant="secondary" className="px-4" style={{ "cursor": "none" }} disabled>Prepare Course</Button>}
            {slides.length > 0 && <Button className="active m-2 px-4" onClick={setPrepare}>Prepare Course</Button>}
            {(slides.length > 0 && Utils.getUserData().pkg_id != 0) && <Button className="active m-2 px-4" onClick={handleDraft}>Save as Draft</Button>}
            {(slides.length > 0 && buyPlan) && <Button className="active m-2 px-4" onClick={handleBuyPlan} >Buy Now</Button>}
            {message && <MessageModal type={message[0]}  message={message[1]} onHide={() => { setMessage(false); }} />}
          </Col>

        </Row>
      </Card.Body>
    </div>
  }

  const renderPrepare = () => {
    return <>
      <div className="instructions">
        <h3 className="my-3">Instructions for preparing & previewing the SVASU package</h3>
        <ol>
          <li>To edit your SVASU package, click on the "Manage Slides" button. </li>
          <li>If you are satisfied with your SVASU package, click the "Prepare and Preview SVASU scorm/web" button to confirm the content before publishing.</li>
        </ol>
      </div>
      <Row className="changeCourseName">
        <Col><Alert variant="warning">
          {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}&altd=${stepData.fname}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" onClick={() => setEditTitle(true)} /></Alert></Col>
      </Row>

      <br />
      <Row>
        <Col className="text-center publishcta">
          {slides.length === 0 && <Button variant="secondary" className="px-4" style={{ "cursor": "none" }} disabled>Prepare & Preview SVASU</Button>}
          {(slides.length > 0 && (Utils.getCourseType() === false || Utils.getCourseType() === 'scorm')) &&
            <Button className="active px-4" onClick={prepareScorm}>Prepare & Preview SVASU Scorm</Button>}
          {(slides.length > 0 && (Utils.getCourseType() === false || Utils.getCourseType() === 'web')) &&
            <Button className="active px-4" onClick={prepareWeb}>Prepare & Preview SVASU Web</Button>}
          <br />
          <strong>Note:</strong> Allow pop-ups in your browser to preview SVASU.<br />
        </Col>
      </Row>
    </>
  }

  const renderPublish = () => {
    return <>
      {/**Instructions section */}
      <div className="instructions">
        <h3 className="my-3">You have successfully created your SVASU.<br />Download it here.</h3>
        <ol>
          <li>Your SVASU package is ready. Click on “Publish & Download Your SVASU”.</li>
          <li>You can always edit your SVASU package by clicking on the “My SVASU” button at the top-right.</li>          
        </ol>
      </div>
      <Row className="changeCourseName">
        <Col><Alert variant="warning">
          {stepData.sprops.photo && <img alt="LOGO" src={Utils.apiUrl(`file?f=${stepData.sprops.photo}&altd=${stepData.fname}`)} className={`rounded ${prepare || publish ? 'text-center' : ''}`} width="50px"></img>} {stepData.sprops.title} <i className="fa fa-pencil clickable pl-1" onClick={() => setEditTitle(true)} /></Alert></Col>
      </Row>

      {/**Button section */}
      {_.get(stepData, 'folder', false) !== false &&
        <div className="text-center">
          <hr />

          {_.get(stepData, 'validity', false) === false &&
            <> <Alert variant="warning">
              <h3 className="text-dark">To Publish and download your scorm</h3>
              {_.get(stepData, 'validityMessage', '') != '' && <Alert>{stepData.validityMessage}</Alert>}
              <a className="btn btn-primary active px-4 mt-2 py-3" href={`${process.env.REACT_APP_URL}/#buy-now`}>Buy Now</a>
            </Alert>
            </>
          }

          {(_.get(stepData, 'validity', false) === true)  && <>
            {/* <Row className="justify-content-center">
              {console.log(stepData.size, "size")}
              {(_.get(stepData, 'cloud', 0) == 1 ) && <Alert variant="secondary" className="col-lg-8 col-sm-12" style={{ borderRadius: "30px" }}>
                <Badge variant="warning">{(parseInt(stepData.storage)/1024).toPrecision(4)} GB</Badge> cloud size is remaining in your account </Alert>}
            </Row> */}
            <Row>
              {flagScorm && <Col>
                <Button className="active px-4" onClick={publishScorm}>Publish & Download Your SVASU</Button>
              </Col>}
              {flagWeb && <Col>
                <Button className="active px-4" onClick={publishWeb}>Publish & Download Your SVASU</Button>
              </Col>}
              {message && <MessageModal type={message[0]} dwn={true} message={message[1]} onHide={() => { setMessage(false); }} />}
            </Row>
          </>}
        </div>}
    </>
  }

  const renderInfo = () => {
    return <> <Card className="noBg">
      <Card className="stepHead">
        {manage && prepare === false && publish === false && <h1>Get Started With Managing Your Slides<span>1 out of 3</span></h1>}
        {prepare && publish === false && <h1>Prepare & Preview Your SVASU<span>2 out of 3</span></h1>}
        {publish && <h1>Your SVASU Package is Ready<span>3 out of 3</span></h1>}
        <div className="steps">
          <ul>
            <li className={`clickable ${(manage && prepare === false && publish === false) ? 'active' : prepare || publish ? 'text-dark' : ''}`} onClick={updateManage}>Manage Slides</li>
            <li className={`${(prepare && publish === false) ? 'active clickable ' : publish ? 'text-dark  ' : 'disable'}`} onClick={updatePrepare}>Prepare & Preview SVASU</li>
            <li className={` ${publish ? 'active clickable' : 'disable'}`} onClick={updatePublish}>Publish SVASU</li>
          </ul>
        </div>
      </Card>

      <Card.Body className="card-box w-100 p-4">
        <div className="progressbarWarp">
          <ProgressBar variant="warning" className="slides-progress"  now={getPkgSize()*2 }  />
          <span >{`${isNaN(getPkgSize())? 0: getPkgSize().toFixed(0)} MB of ${getMaxScormSize()} MB used.`}</span>
        </div>
        {manage && prepare === false && publish === false && renderManage()}

        {prepare && publish === false && renderPrepare()}

        {publish && renderPublish()}

        {loading && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="warning" now={100} /></Alert></div>}
      </Card.Body>
    </Card>
      {(prepare || publish) && <><br /> <br /><br /> </>}</>
  }

  const addSlideHandler = (e) => {
    if(getPkgSize().toFixed(0) >= 50){
      alert("You have exhausted your SVASU size limit.");
      return;
    }
    setSlideParams({ ...slideParams, show: true, pos: e.currentTarget.getAttribute('pos'), mode: 0, type: false, data: {} });
  }

  const removeSlideHandler = (e) => {
    if (window.confirm("Are you sure you want to delete this slide?")) {
      var tmp = [...slides];
      _.remove(tmp, s => parseInt(s.sid) === parseInt(e.currentTarget.getAttribute('sid')));
      setSlides(tmp);
      setRemove(true);
      e.stopPropagation();
      e.preventDefault();
    }

  }

  const openSlideEditor = (e) => {
    var idx = slides.findIndex(s => parseInt(s.sid) === parseInt(e.currentTarget.getAttribute('sid')));
    let src = '';
    if(slides[idx].type === 'Photo'){
      src = e.currentTarget.getAttribute('src');
    } 
    if(_.get(slides[idx], 'fileStep',false)){
      //checks whether photo is from file process or not
      setSlideParams({ ...slideParams, show: true, pos: idx + 1, mode: 1, type: slides[idx].type, data: slides[idx], src:src });
    }
    else{
      setSlideParams({ ...slideParams, show: true, pos: idx + 1, mode: 1, type: slides[idx].type, data: slides[idx].data, src:src });
    }
  }
  const hideAdd = () => {
    setSlideParams({ ...slideParams, show: false });
  }

  const showType = (e) => {
    var btn = e.currentTarget;
    setSlideParams({ ...slideParams, type: btn.getAttribute('tname') });
  }

  const showAddDialog = () => {

    return <Modal
      show={slideParams.show}
      onHide={hideAdd}
      backdrop="static"
      keyboard={false}
      size={slideParams.type && (slideParams.type === 'Question' || slideParams.type === 'Template') ? 'xl' : 'lg'}
    >
      <Modal.Header closeButton className="slInsPop">

      </Modal.Header>

      {!slideParams.type && showSlideInstructions()}

      {slideParams.type === 'Photo' && <PhotoForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Question' && <QuestionForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Video' && <VideoForm onFinalize={onFinalize} {...slideParams} />}
      {slideParams.type === 'Template' && <CustomTemplateList onSlideSave={onFinalize} {...slideParams} />}
      {slideParams.type === 'File' && <FileForm onFinalize={onFinalize} {...slideParams} />}

    </Modal>;
  }

  const getNextSlideId = () => {
    if (slides.length > 0) {
      return parseInt(_.maxBy(slides, 'sid').sid) + 1;
    } else {
      return 1;
    }
  }

  const onFinalize = (data, type, mode = 0) => {
    var tmp = [...slides];
    if (mode) {
      if(type === 'File'){
        data.map((d, idx) => {
          const slide = {sid: getNextSlideId() + idx, 
                          folder: d.folder,
                          fileStep: 'within', //fileStep : step level at which file uploaded
                                          //init : file uploaded at step2 /initial level
                                          //within : file uploaded at step3/within scorm levels
                          title:d.sname.substr(0, d.sname.length - 4), 
                          sname:d.sname, 
                          type: 'Photo',
                          size: {'photo' : d.size, 'audio' : 0}};
          if(tmp.length <= slideParams.pos){
            tmp.push(slide);
          }
          else{
            tmp.splice(parseInt(slideParams.pos) + idx, 0, slide);
          }
        });
      }else{
        if(tmp[parseInt(slideParams.pos) - 1].folder){
          tmp[parseInt(slideParams.pos) - 1] = data;
        }else{
          tmp[parseInt(slideParams.pos) - 1]['data'] = data;
        }        
      }
    } else{
      let slide = { sid: getNextSlideId(), type: type, data: data};
      if(tmp.length <= slideParams.pos){
        if(type === 'Photo'){          
          tmp.splice(parseInt(slideParams.pos), 0, slide);
        }else{          
          tmp.push(slide);
        }        
      }
      else{
        tmp.splice(parseInt(slideParams.pos), 0, slide);
      }
    }
    setSlides(tmp);
    setSlideParams({ ...slideParams, show: false });
  }

  const showSlideInstructions = () => {
    return <>
      <Modal.Body className="slInstruction">
        <Row className="mt-2 clickable" tname="Photo" onClick={showType}>
          <Col sm={1}>   <img src={`${process.env.PUBLIC_URL}/images/pic.png`} alt="Image" /></Col>
          <Col>Click here to upload the image and audio file.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Question" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/quizz_icon.png`} alt="Question Slide" /></Col>
          <Col>Click here to add a quiz with answers.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Video" onClick={showType}>
          <Col sm={1}> <img src={`${process.env.PUBLIC_URL}/images/video.png`} alt="Video" /></Col>
          <Col>Click here to upload the video.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="Template" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/custom_slide.png`} alt="Custom Slide" /></Col>
          <Col>Click here to add customized templates.</Col>
        </Row>
        <Row className="mt-2 clickable" tname="File" onClick={showType}>
          <Col sm={1}><img src={`${process.env.PUBLIC_URL}/images/pdf-ppt.png`} alt="Custom Slide" /></Col>
          <Col>Click here to add a pdf / ppt file.</Col>
        </Row>
      </Modal.Body>
    </>;
  }


  const isScormCountable = () => {
    return slides.findIndex(s => s.type === "Question" && s.data.countable) > -1;
  }

  return <>
    {renderInfo()}
    {showAddDialog()}

    {editTitle && <AskTitle data={stepData} edit="true" onHide={() => setEditTitle(false)} onSuccess={changeTitle} countable={isScormCountable()} />}
  </>;
}

export default Step3;